import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ReadjustmentRequestDto } from '@app/data/dtos/ptrab/irpf-readjustment/readjustment-request.dto';
import {
  IRPF_READJUSTMENT_REPOSITORY,
  IrpfReadjustmentRepository
} from '@app/domain/repositories/ptrab/irpf-readjustment/irpf-readjustment.repository.contract';
import { TwoFactorAuthorization } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { Readjustment } from '@app/entities/models/ptrab/irpf-readjustment/readjustment.model';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

import { IrpfReadjustmentUseCases } from './irpf-readjustment.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class IrpfReadjustmentUseCasesImpl implements IrpfReadjustmentUseCases {
  #irpfReadjustmentRepository: IrpfReadjustmentRepository = inject(IRPF_READJUSTMENT_REPOSITORY);

  getReadjustment(): Observable<Readjustment> {
    return this.#irpfReadjustmentRepository.getReadjustment();
  }

  setRegularization(params: ReadjustmentRequestDto, authorization: TwoFactorAuthorization): Observable<MSafeAny> {
    return this.#irpfReadjustmentRepository.setRegularization(params, authorization);
  }
}
